export const CATEGORY_OPTIONS = [
  { value: 'event', label: 'Event (table, space, sponsorship)' },
  { value: 'receipt', label: 'Receipt / general expense' },
  { value: 'supplies', label: 'Supplies / materials' },
  { value: 'other', label: 'Other' },
];

export const CATEGORY_LABEL = {
  event: 'Event',
  receipt: 'Receipt / expense',
  supplies: 'Supplies / materials',
  other: 'Other',
};

export const STATUS_META = {
  submitted: { label: 'Submitted', cls: 'bg-sky-50 text-sky-700 border-sky-200' },
  under_review: { label: 'In review', cls: 'bg-amber-50 text-amber-700 border-amber-200' },
  approved: { label: 'Approved', cls: 'bg-indigo-50 text-indigo-700 border-indigo-200' },
  paid: { label: 'Paid', cls: 'bg-emerald-50 text-emerald-700 border-emerald-200' },
  rejected: { label: 'Rejected', cls: 'bg-rose-50 text-rose-700 border-rose-200' },
  cancelled: { label: 'Cancelled', cls: 'bg-slate-100 text-slate-500 border-slate-200' },
};

export const money = (n) => `$${Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
